import Image from 'core/display/Image'
import { signal } from 'services/SignalsService'
import { choicePopup } from 'settings/custom/freespins'
import { delay } from 'utils/Delay'

export default class ChoiceImage extends Image {
  constructor(data) {
    super(data)
    this.fs = this._data.name.split('-')[0]
    this.state = this._data.name.split('-')[1]
    this.prepare()
  }

  get data(){
    return this._data
  }

  prepare() {
    this.alpha = 0
    if (this.state == 0){
      this.alpha = 1
    }

    signal.on('ACTION:FS-START', this.reset.bind(this))
    signal.on('CHOISE-START', this.makeChoice.bind(this))
  }

  reset(){
    this.alpha = 0
    if (this.state == 0){
      this.alpha = 1
    }
  }

  async makeChoice() {
    this.alpha = 0
    if (this.state == 0){
      this.alpha = 1
    }
    const freespins = game.models.FreespinModel.get()
    const settings = {
      counter: 8,
      time: 0.7,
      10: freespins.all == choicePopup.first,
      15: freespins.all == choicePopup.second,
    }

    await this.choice(settings, this.state)
    await this.choiceStart(settings,  this.fs,  this.state)
    await this.choiceReady(settings,  this.fs,  this.state)

  }

  async choice(settings, state) {
    this.alpha = state == 0 ? 1 : 0
    await delay(settings.time)
  }

  async choiceStart(settings, fs, state) {
    for (settings.counter; settings.counter > 0; settings.counter--) {
      if ((settings[fs] && state == 1) || (!settings[fs] && state == 0)) {
        this.alpha = 1
      }
      else {
        this.alpha = 0
      }
      settings[fs] = !settings[fs]
      await delay(settings.time)
    }
  }

  async choiceReady(settings, fs, state) {
    if (settings[fs] && state == 2) {
      signal.dispatch('CHOICE-READY')
      this.alpha = 1
    }
    else if (!settings[fs] && state == 0) {
      this.alpha = 1
    }
    else {
      this.alpha = 0
    }
  }

}
